<template>
  <div class="conmon-top">
    <el-row>
      <el-col :span="24">
        <div class="grid-content-one" style="text-align: left">
          标签名称：<span style="color:#1980ff;font-size: 14px;margin:0 12px 0 8px;">{{totalNameSum}}</span> 标记人数：<span style="color:#1980ff;font-size: 14px;margin:0 12px 0 8px;">{{totalCountSum}}</span>
        </div>
      </el-col>
    </el-row>
    <el-container>
      <div class="customer_label_statistics">
        <!-- <ul class="title_nav">
          <li :class="{ active: (activeName === 1) }" @click="activeName = 1">受众</li>
          <li :class="{ active: (activeName === 2) }" @click="activeName = 2">微页面</li>
          <li :class="{ active: (activeName === 3) }" @click="activeName = 3">大转盘</li>
          <li :class="{ active: (activeName === 4) }" @click="activeName = 4">公众号二维码</li>
          <li :class="{ active: (activeName === 5) }" @click="activeName = 5">线下活动</li>
        </ul> -->
        <el-tabs class="setting-tabs label-tabs" v-model="activeName" @tab-click="getData">
          <el-tab-pane label="受众" name="1">
            <el-table
              :data="tableData"
              style="margin:0 auto;"
              :header-cell-style="{background: '#FAFAFA'}"
              class="table"
              v-loading="loadList">
              <el-table-column
                prop="realname"
                width="80"
                label="客户">
              </el-table-column>
              <el-table-column
                prop="source"
                width="120"
                label="来源">
              </el-table-column>
              <el-table-column
                prop="source_content"
                label="来源描述">
              </el-table-column>
              <el-table-column
                prop="area"
                label="区域">
              </el-table-column>
              <el-table-column
                prop="stage"
                width="120"
                label="当前等级">
              </el-table-column>
              <el-table-column
                width="135"
                label="创建时间">
                <template slot-scope="scope">
                  {{ scope.row.customer_create_time | formatDate }}
                </template>
              </el-table-column>
            </el-table>
          </el-tab-pane>
          <el-tab-pane label="微页面" name="2">
            <el-table
              :data="tableData"
              style="margin:0 auto;"
              :header-cell-style="{background: '#FAFAFA'}"
              class="table"
              v-loading="loadList">
              <el-table-column
                prop="scene_name"
                width="300"
                label="名称">
                <template slot-scope="scope">
                  <router-link :to="{ path: 'micro-page-edit', query: { id: scope.row.relation_id }}" class="op-link">
                    {{scope.row.scene_name}}
                  </router-link>
                </template>
              </el-table-column>
              <el-table-column
                prop="people_count"
                label="标记人数">
              </el-table-column>
            </el-table>
          </el-tab-pane>
          <el-tab-pane label="大转盘" name="3">
            <el-table
              :data="tableData"
              style="margin:0 auto;"
              :header-cell-style="{background: '#FAFAFA'}"
              class="table"
              v-loading="loadList">
              <el-table-column
                prop="lottery_name"
                width="300"
                label="名称">
                <template slot-scope="scope">
                  <router-link :to="{ path: 'edit-activity', query: { id: scope.row.relation_id }}" class="op-link">
                    {{scope.row.lottery_name}}
                  </router-link>
                </template>
              </el-table-column>
              <el-table-column
                prop="people_count"
                label="标记人数">
              </el-table-column>
            </el-table>
          </el-tab-pane>
          <el-tab-pane label="公众号二维码" name="4">
            <el-table
              :data="tableData"
              style="margin:0 auto;"
              :header-cell-style="{background: '#FAFAFA'}"
              class="table"
              v-loading="loadList">
              <el-table-column
                prop="qrcode_name"
                width="300"
                label="名称">
                <template slot-scope="scope">
                  <router-link :to="{ path: 'qrcode-edit', query: { id: scope.row.relation_id,original_id: scope.row.original_id, public_id: scope.row.public_id }}" class="op-link">
                    {{scope.row.qrcode_name}}
                  </router-link>
                </template>
              </el-table-column>
              <el-table-column
                prop="people_count"
                label="标记人数">
              </el-table-column>
            </el-table>
          </el-tab-pane>
          <el-tab-pane label="线下活动" name="5">
            <el-table
              :data="tableData"
              style="margin:0 auto;"
              :header-cell-style="{background: '#FAFAFA'}"
              class="table"
              v-loading="loadList">
              <el-table-column
                prop="activity_name"
                width="300"
                label="名称">
                <template slot-scope="scope">
                  <router-link :to="{ path: 'edit-offline-activity', query: { id: scope.row.relation_id }}" class="op-link">
                    {{scope.row.activity_name}}
                  </router-link>
                </template>
              </el-table-column>
              <el-table-column
                prop="people_count"
                label="标记人数">
              </el-table-column>
            </el-table>
          </el-tab-pane>
        </el-tabs>
        <div class="table-foot" style="text-align: right">
          <el-pagination
            class="table-foot-pagination"
            background
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="page"
            :page-size="limit"
            layout="total, prev, pager, next, jumper"
            :total="totalCount">
          </el-pagination>
        </div>
      </div>
    </el-container>
  </div>
</template>
<script>
import { tagStatistic } from '@/api/customer.js'
export default {
  name: 'customerLabelStatistics',
  data () {
    return {
      totalNameSum: this.$route.query.name,
      id: this.$route.query.id,
      loadList: true,
      activeName: '1',
      totalCountSumShow: true,
      totalCountSum: 0,
      tableData: [],
      totalCount: 0,
      page: 1,
      limit: 10
    }
  },
  methods: {
    getData() {
      this.loadList = true
      let data = {
        page: this.page,
        limit: this.limit,
        type: ''
      }
      if (this.activeName === '1') {
        data.type = 'customer'
      } else if (this.activeName === '2') {
        data.type = 'scene'
      } else if (this.activeName === '3') {
        data.type = 'lottery'
      } else if (this.activeName === '4') {
        data.type = 'wechat_qrcode'
      } else if (this.activeName === '5') {
        data.type = 'off_line_activity'
      }
      tagStatistic(this.id, data).then(res => {
        this.loadList = false
        if (res.data.code === 0) {
          console.log(res.data.data)
          this.tableData = res.data.data.list
          this.totalCount = res.data.data.total
          if (this.totalCountSumShow) {
            this.totalCountSum = res.data.data.peopleTotal
            this.totalCountSumShow = false
          }
        } else {
          _g.toastMsg('error', res.data.error)
        }
      })
    },
    handleSizeChange(val) {
      this.limit = val
      this.getData()
    },
    handleCurrentChange(val) {
      this.page = val
      this.getData()
    }
  },
  mounted() {
    this.getData()
  },
  created() {
  }
}
</script>
<style scoped>
.grid-content-one{
  margin: 20px 20px 0;
  background: #fff;
  line-height: 50px;
  height: 50px;
  box-sizing: border-box;
  padding-left: 15px;
}
.customer_label_statistics{
  width: 100%;
  margin: 20px 20px 0;
  background: #fff;
  min-height: 500px;
}
.title_nav{
  margin: 0;
  padding: 0;
  width: 100%;
  height: 50px;
}
.title_nav li{
  list-style: none;
  line-height: 48px;
  padding: 0 20px;
  float: left;
  display: inline-block;
  margin: 0;
  border-bottom: 2px solid #fff;
  cursor: pointer;
  transition: all 0.5s;
}
.title_nav li:hover{
  color: #1980FF;
}
.title_nav li.active{
  border-bottom: 2px solid #1980FF;
  color: #1980FF;
}
</style>
